import { Component, OnInit, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

import { activityInput } from "../models/activityInput.model";
import { GSFReport } from "../GSF-report.service";
import { constants } from "../constants/constants";

@Component({
  selector: "app-text-box",
  templateUrl: "./text-box.component.html",
  styleUrls: ["./text-box.component.css"]
})
export class TextBoxComponent implements OnInit {
  @Input() activity: activityInput;
  @Input() isRequired: boolean;
  selectedlang: string;

  @Input() activityControl: UntypedFormControl;

  constructor(public report: GSFReport, public translate: TranslateService) {
    translate.setDefaultLang(constants.LANGUAGE);
    this.selectedlang = constants.LANGUAGE;
  }

  ngOnInit() {
  }

}
